import { useEffect, useState } from 'react';
import { extractLastUpdated, renderSimpleMarkdown } from './markdown';
import { readBuildMetadata } from './types';

export interface LegalMarkdownPageProps {
  /** Path under public, e.g. `/legal/privacy.md` */
  markdownPath: string;
  title: string;
}

export function LegalMarkdownPage({ markdownPath, title }: LegalMarkdownPageProps) {
  const [html, setHtml] = useState('');
  const [lastUpdated, setLastUpdated] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      try {
        const cacheKey = readBuildMetadata().gitCommit?.trim() || 'dev';
        const url = `${markdownPath}?v=${encodeURIComponent(cacheKey)}`;
        const res = await fetch(url);
        if (!res.ok) throw new Error(`Could not load ${markdownPath}`);
        const text = await res.text();
        if (!cancelled) {
          setLastUpdated(extractLastUpdated(text));
          setHtml(renderSimpleMarkdown(text, { pageTitle: title }));
        }
      } catch (e) {
        if (!cancelled) setError(e instanceof Error ? e.message : 'Failed to load content.');
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [markdownPath, title]);

  return (
    <div className="user-settings-standalone site-support-legal" style={{ overflow: 'auto', height: '100%' }}>
      <div className="user-settings-standalone__card">
        <h2 className="dashboard-title">{title}</h2>
        {lastUpdated ? <p className="site-support-legal__updated">{lastUpdated}</p> : null}
        {error ? <p className="site-support-error">{error}</p> : null}
        {!error && html ? (
          <div
            className="site-support-legal__body site-support-legal__prose"
            dangerouslySetInnerHTML={{ __html: html }}
          />
        ) : null}
      </div>
    </div>
  );
}
